import { MutableRefObject, useEffect, useRef } from 'react';

// HOOK: a ref continuously synced to the latest render's value — read `.current` in event
// handlers/effect cleanups (never during render) to get fresh state without dep churn.
export const useLatestRef = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);
  useEffect(() => { ref.current = value; });
  return ref;
};
